import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=18f34de8&"
import script from "./not-found.vue?vue&type=script&lang=ts&"
export * from "./not-found.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports